import { ShoppingBag } from 'lucide-react';

export const shopifyIntegration = {
    id: 'shopify',
    name: 'Shopify',
    icon: ShoppingBag,
    platformColor: '#95BF47',
    title: 'Shopify Setup',
    why: 'Providing exceptional customer support is crucial for the success of your Shopify store. ChytBot helps you achieve that with AI-powered assistance.',
    detailedGuide: '/docs/shopify',
    steps: [
        {
            title: "Copy the Chatbot’s Code Snippet",
            desc: "A unique code snippet will be generated for your chatbot. Click **\"Copy code\"** to save the code to your clipboard, ensuring you capture the full snippet.",
            image: "/docs/screenshots/shopify/integration.jpg",
            imgAlt: "Copying embed code"
        },
        {
            title: "Open Your Shopify Admin Panel",
            desc: "Log in to your Shopify admin dashboard using your Shopify credentials. From the left-hand menu, click \"Online Store\" under the Sales Channels section.",
            image: "/docs/screenshots/shopify/shopify-online-store-menu.png",
            imgAlt: "Shopify Admin"
        },
        {
            title: "Edit Your Theme Code",
            desc: "In the Themes section, locate your current theme. Click the ellipsis (•••) icon next to the theme and select \"Edit Code\" to access the theme files.",
            image: "/docs/screenshots/shopify/shopify-edit-code-button.png",
            imgAlt: "Edit Code"
        },
        {
            title: "Open the theme.liquid File",
            desc: "Scroll through the list of theme files under the “Layout” section in the left panel. Click on theme.liquid to open it for editing.",
            image: "/docs/screenshots/shopify/shopify-theme-liquid-file.png",
            imgAlt: "theme.liquid"
        },
        {
            title: "Insert the Chatbot Code Snippet",
            desc: "Find the <head> section in theme.liquid and paste the copied code snippet anywhere between the <head> and </head> tags.",
            image: "/docs/screenshots/shopify/shopify-head-tag-location.png",
            imgAlt: "Pasting code"
        },
        {
            title: "Save and Publish Changes",
            desc: "After pasting the embed code, click \"Save\" in the top right corner of the editor. Your chatbot is now live on your Shopify store!",
            image: "/docs/screenshots/shopify/shopify-edit-code-button.png",
            imgAlt: "Save Changes"
        },
        {
            title: "Test the Chatbot",
            desc: "Refresh your Shopify store front-end to confirm that the chatbot appears. Send a test message to confirm it responds correctly.",
            image: "/docs/screenshots/shopify/shopify-live-chatbot.png",
            imgAlt: "Live Test"
        }
    ]
};
